<template>
  <div class="schedule-panel"
    :style="panelStyle"
    @touchstart.passive="onTouchStart"
    @touchend.passive="onTouchEnd"
  >
    <div class="panel-header" ref="panelHeader">
      <div class="head">
        <div @click="showPicker = true">
          <span>{{ columns[selectIndex[0]]?.text }}</span>
          <span>
            {{ columns[selectIndex[0]]?.children[selectIndex[1]].text }}
          </span>
          <img
            :src="require('@/assets/imgs/schedule/down.svg')"
            class="title"
            alt
          />
        </div>
      </div>
      <DateTab :active.sync="dateTab" :dateData="dateDataModal" />
    </div>
    <div class="panel-content" ref="panelContent">
      <div v-if="loading" class="loading-wrap">
        <van-loading type="spinner" color="#F80000" />
      </div>
      <template v-else>
        <div
          class="scheduleWrap"
          v-for="(group, groupKey) in scheduleModal"
          :key="groupKey"
        >
          <div class="dateTitle">{{ groupKey }}</div>
          <ScheduleItem
            v-for="(item, key) in group"
            :key="group + '' + key"
            :data="item"
          />
        </div>
      </template>
    </div>
    <van-popup v-model="showPicker" round position="bottom" get-container="body">
      <van-picker
        :columns="columns"
        toolbar-position="bottom"
        :show-toolbar="true"
        :item-height="36"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        :visible-item-count="5"
        class="selectGroup"
        :confirm-button-text="$t('home.confirm')"
        :cancel-button-text="$t('home.cancel')"
      >
        <div slot="columns-top" class="dragWrap">
          <img :src="require('@/assets/imgs/comm/drag.svg')" alt />
        </div>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { getMatchList } from "@/service/Schedule";
import DateTab from "./components/DateTab";
import ScheduleItem from "./components/ScheduleItem";
import { Format } from "@/utils/fn";
import { getWeek } from "@/utils/time";
import { sphList, matchList, stageGroup } from "@/utils/filedList";
import { Popup, Picker, Loading } from "vant";
import { mapState } from "vuex";
import { getLang } from '@/utils/lng'

export default {
  name: "Schedule",
  components: {
    DateTab,
    ScheduleItem,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Loading.name]: Loading,
  },
  data() {
    return {
      active: "",
      dateTab: "all",
      dateData: [],
      scheduleData: [],
      groupDate: [],
      knockoutStageDate: [],
      fetchTimer: null,
      loading: true,
      showPicker: false,
      columns: [],
      menus: [],
      selectIndex: [0, 0],
      // ---- 浮动面板 ----
      translateY: 313,
      isDragging: false,
      maxTranslateY: 0,
    };
  },
  created() {
    this.getMatchList(true);
    this.startQueue();
  },
  mounted() {
    this.$nextTick(() => {
      // 面板 top 在 translateY=0 时为 44px (100dvh - 44px 的 height, bottom:0)
      // 初始位置对齐 viewContent（margin-top: 357px 在 Home 滚动容器内）
      const parent = this.$el.parentElement;
      if (parent) {
        const parentTop = parent.getBoundingClientRect().top;
        this.maxTranslateY = parentTop - 44;
      } else {
        this.maxTranslateY = 313; // fallback: 357 - 44
      }
      this.translateY = this.maxTranslateY;
      // 非 passive 以便在拖拽面板时 preventDefault
      this.$el.addEventListener('touchmove', this.onTouchMove, { passive: false });
    });
  },
  destroyed() {
    clearInterval(this.fetchTimer);
    this.fetchTimer = null;
    if (this.$el) {
      this.$el.removeEventListener('touchmove', this.onTouchMove);
    }
  },
  computed: {
    panelStyle() {
      return {
        transform: `translateY(${this.translateY}px)`,
        transition: this.isDragging ? 'none' : 'none',
      };
    },
    expanded() {
      return this.translateY <= 0;
    },
    scheduleModal() {
      let _data = this.scheduleModalData.reduce((prev, item) => {
        if (
          item.value &&
          (this.dateTab == "all" || item.dateTime == this.dateTab)
        ) {
          prev[item.dateTime] = prev[item.dateTime] || [];
          prev[item.dateTime].push(item);
        }
        return prev;
      }, {});
      return _data;
    },
    scheduleModalData() {
      if (this.columns.length) {
        let active =
          this.columns[this.selectIndex[0]].children[this.selectIndex[1]].value;
        return this.scheduleData.filter((item) => {
          return (
            (this.activeGroupValueModal.indexOf(item.value) > -1 ||
              item.value == active) &&
            (this.dateTab == "all" || item.dateTime == this.dateTab)
          );
        });
      }
      return [];
    },
    activeGroupValueModal() {
      if (this.columns.length) {
        let active =
          this.columns[this.selectIndex[0]].children[this.selectIndex[1]].value;
        let _active = active ? active + "" : "";
        let idx = _active.indexOf("all");
        if (idx > -1) {
          let activeId = _active.replace("all", "");
          return stageGroup[activeId].group;
        }
      }
      return [];
    },
    dateDataModal() {
      if (this.columns.length) {
        let active =
          this.columns[this.selectIndex[0]].children[this.selectIndex[1]].value;
        return this.dateData.filter((item) => {
          let hasGroupVal = false;
          if (this.activeGroupValueModal.length) {
            hasGroupVal = this.activeGroupValueModal.find((groupVal) => {
              return item.groupValueArr.indexOf(groupVal) > -1;
            });
          }
          return hasGroupVal || item.groupValueArr.indexOf(active) > -1;
        });
      }
      return [];
    },
    selectData() {
      const matchArr = [9, 10, 11, 12, 13];
      let matchVal = this.columns[this.selectIndex[0]].values;
      let groupVal =
        this.columns[this.selectIndex[0]].children[this.selectIndex[1]].values;
      return this.scheduleData.filter((item) => {
        return (
          ((matchVal == "all" && !(matchArr.indexOf(item.sph) > -1)) ||
            item.sph == matchVal) &&
          (groupVal == "all" || item.sph == groupVal)
        );
      });
    },
    languageType() {
      return this.common.languageType;
    },
    ...mapState(["common"]),
  },
  methods: {
    // ---- 面板拖拽 ----
    onTouchStart(e) {
      this._startX = e.touches[0].clientX;
      this._startY = e.touches[0].clientY;
      this._startTranslateY = this.translateY;
      this._startContentScrollTop = this.$refs.panelContent?.scrollTop || 0;
      this.isDragging = true;
      this._draggingPanel = false;
      this._directionLocked = false;
      this._isHorizontal = false;
      document.body.style.overflow = 'hidden';
    },
    onTouchMove(e) {
      if (!this.isDragging) return;
      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      const deltaX = currentX - this._startX;
      const deltaY = currentY - this._startY;

      if (!this._directionLocked) {
        if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) {
          this._directionLocked = true;
          this._isHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
        } else {
          return;
        }
      }
      if (this._isHorizontal) return;

      const contentEl = this.$refs.panelContent;

      // 面板未展开 → 拖拽面板
      if (this._startTranslateY > 0) {
        e.preventDefault();
        this._draggingPanel = true;
        const newY = this._startTranslateY + deltaY;
        this.translateY = Math.max(0, Math.min(this.maxTranslateY, newY));
        return;
      }

      // 面板已展开，在内容顶部向下拖 → 收起面板
      if (this._startContentScrollTop <= 0 && deltaY > 0) {
        // 一旦开始拖面板，锁定为面板模式
        if (!this._draggingPanel && contentEl.scrollTop <= 0) {
          this._draggingPanel = true;
        }
        if (this._draggingPanel) {
          e.preventDefault();
          this.translateY = Math.max(0, Math.min(this.maxTranslateY, deltaY));
          return;
        }
      }
      // 其他情况: 正常滚动内容，不 preventDefault
    },
    onTouchEnd(e) {
      if (!this.isDragging) return;
      this.isDragging = false;
      document.body.style.overflow = '';
      const deltaY = e.changedTouches[0].clientY - this._startY;
      if (deltaY > 0) {
        // 向下滑 → 想收起，30% 即可触发
        if (this.translateY > this.maxTranslateY * 0.1) {
          this.translateY = this.maxTranslateY;
        } else {
          this.translateY = 0;
        }
      } else {
        // 向上滑 → 想展开，滑过 70% 就回弹收起，否则展开
        if (this.translateY > this.maxTranslateY * 0.9) {
          this.translateY = this.maxTranslateY;
        } else {
          this.translateY = 0;
        }
      }
    },
    // ---- 业务逻辑 ----
    onConfirm(currentValue, currentIndex) {
      this.dateTab = "all";
      this.selectIndex = currentIndex;
      this.showPicker = false;
    },
    menusHandle(val) {
      this.active = val;
    },
    startQueue() {
      if (this.fetchTimer) {
        clearInterval(this.fetchTimer);
        this.fetchTimer = null;
      }
      this.fetchTimer = setInterval(() => {
        this.getMatchList();
      }, 5000);
    },
    getMatchList(firstLoad) {
      getMatchList({ languageType: getLang(this.languageType) }).then((res) => {
        if (res.success) {
          this.buildData(res.data, firstLoad);
        }
        
        setTimeout(() => {
           if (firstLoad) this.loading = false;
        }, 300)
      });
    },
    buildDate(btm) {
      let dateTime = Format(new Date(btm), "yyyy-MM-dd");
      let formatWeek = getWeek(btm)[this.getLocal()];
      let dateFormat = Format(new Date(btm), "M-d");
      return {
        dateTime,
        formatWeek,
        dateFormat,
        btm,
      };
    },
    buildGroup(sph) {
      if (sphList[sph]) {
        return {
          value: sph,
          text: sphList[sph][this.getLocal()],
          groupSort: sphList[sph].sort || sphList[sph].EN,
        };
      }
      if (matchList[sph]) {
        return {
          value: sph,
          text: matchList[sph][this.getLocal()],
          groupSort: matchList[sph].groupSort,
        };
      }
      if (!sphList[sph] && !matchList[sph]) return false;
    },
    buildData(data, firstLoad) {
      let scheduleTemp = [];
      let dateDataTemp = [];
      let menusTemp = [];
      let _firstData = false;
      data.forEach((item) => {
        let itemTemp = { ...item };
        const timeObj = this.buildDate(item.btm);
        let hasOne = dateDataTemp.find((dateItem) => {
          if (dateItem.dateTime == timeObj.dateTime) {
            dateItem.groupValueArr.push(item.sph);
            return true;
          }
        });
        let groupTemp = this.buildGroup(item.sph);
        if (!groupTemp) {
          return;
        }
        if (!hasOne) {
          timeObj.groupValueArr = [item.sph];
          timeObj.text = groupTemp.text;
          timeObj.value = groupTemp.value;
          dateDataTemp.push(timeObj);
        }
        let hasOneGroup = menusTemp.find(
          (item) => item.value == groupTemp.value
        );

        let stageVal = [];
        if (sphList[item.sph]) {
          stageVal = Object.values(stageGroup).filter((item) => {
            return item.group.includes(itemTemp.sph);
          });
        }
        if (stageVal.length) {
          const hasStage = menusTemp.find((menu) => {
            if (menu.children) {
              return menu.children.find((stage) => {
                return stageVal[0].group.includes(stage.value);
              });
            }
            return menu.value == groupTemp.value;
          });
          if (!hasStage) {
            menusTemp.push({
              value: stageVal[0].id,
              text: stageVal[0][this.getLocal()],
              groupSort: stageVal[0].sort,
              children: [
                {
                  value: "all" + stageVal[0].id,
                  text: this.$t("home.All"),
                  groupSort: "A",
                },
                groupTemp,
              ],
            });
          } else {
            let hasTem = hasStage.children.find((stage) => {
              return stage.value == groupTemp.value;
            });
            if (!hasTem) {
              hasStage.children.push(groupTemp);
            }
          }
        } else if (!hasOneGroup) {
          menusTemp.push({
            ...groupTemp,
            children: [
              {
                value: groupTemp.value,
                text: this.$t("home.All"),
                groupSort: "A",
              },
            ],
          });
        }
        itemTemp = { ...itemTemp, ...timeObj, ...groupTemp };
        scheduleTemp.push(itemTemp);
      });
      this.dateData = dateDataTemp.sort(
        (curr, next) => new Date(curr.btm) - new Date(next.btm)
      );
      menusTemp.forEach((item) => {
        if (item.children) {
          item.children = item.children.sort((a, b) =>
            (a.groupSort + "").localeCompare(b.groupSort + "")
          );
        }
      });
      if (!this.columns.length) {
        this.columns = menusTemp.sort((a, b) =>
          (a.groupSort + "").localeCompare(b.groupSort + "")
        );
      }

      if (this.active === false) {
        this.active = this.columns[0].children
          ? this.columns[0].children[0].value
          : this.columns[0].value;
      }
      this.scheduleData = scheduleTemp.sort(
        (curr, next) => curr.btm - next.btm
      );
      this.scheduleData.forEach(item => {
        if((item.st === undefined || item.st === 4) && !_firstData && firstLoad){
          _firstData = item;
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule-panel {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(100dvh - 44px);
  display: flex;
  flex-direction: column;
  background: var(--color-5);
  border-radius: 20px 20px 0 0;
  z-index: 10;
  will-change: transform;
}

.panel-header {
  flex-shrink: 0;
  user-select: none;
}

.head {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  background: #fff;
  border-radius: 20px 20px 0 0;
  overflow: hidden;

  * {
    margin-right: 4px;
    vertical-align: -webkit-baseline-middle;
  }
  span {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    &:first-child {
      font-weight: 600;
    }
  }
}

.panel-content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding-bottom: 80px;

  .loading-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 80px;
  }
}

.scheduleWrap {
  margin: 4px 8px 0;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  .dateTitle {
    height: 40px;
    padding-left: 16px;
    position: relative;
    line-height: 40px;
    background: #fbfbfb;
    color: #333958;
    font-weight: 500;
    &::before {
      content: " ";
      position: absolute;
      width: 4px;
      left: 0px;
      top: 20%;
      bottom: 17.5%;
      border-radius: 0 5px 5px 0;
      background: #F80000;
    }
  }
}

.dragWrap {
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss">
.selectGroup {
  .van-picker__toolbar {
    button {
      flex: 1;
      color: #fff;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      color: #ffffff;
    }
    .van-picker__cancel {
      background: #aeb4bd;
    }
    .van-picker__confirm {
      background: #F80000;
    }
  }
}
.dark {
  .schedule-panel {
    .head {
      background: none;
      color: #ffffff;
    }
    .scheduleWrap {
      background: var(--color-10);
      .scheduleItem {
        &:last-child {
          border: none;
        }
      }
      .dateTitle {
        background: none;
        color: #ffffff;
      }
    }
  }
}

.dark-theme {
  .van-popup {
    .van-picker {
      background: var(--color-15);
    }
    background: var(--color-10);
    [class*='van-hairline']::after {
      border: 0 solid #2B2C30;
      border-width: 1px 0;
    }
    .van-picker-column__item {
      color: #fff;
      opacity: 0.4;

      &.van-picker-column__item--selected {
        opacity: 1;
      }
    }
    .van-picker__mask {
      background: none;
    }
  }
}
</style>
